import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const ArticleHeader = styled.header`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  background: #f8f8f8;
  height: 300px;
  @media (min-width: ${breakpoints.desktop}) {

  }
`;

export default ArticleHeader;



// WEBPACK FOOTER //
// ./src/styled-components/ArticleHeader.js